<template>
  <v-snackbar
    v-model="hasVisibleDownloads"
    app
    bottom
    left
    light
    color="white"
    class="downloads-list"
    elevation="24"
    :timeout="-1"
    transition="scale-transition"
    origin="center center"
  >
    <DownloadEntry
      v-for="download of visibleDownloadRequests"
      :key="download.id"
      v-model="download.visible"
      :entry="download"
    />
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { subscribeToDownloadsChannel } from '@/channels/downloads_channel'

import { DOWNLOADS_NAMESPACE } from '@/store/downloads'

import DownloadEntry from './DownloadEntry.vue'

export default {
  name: 'DownloadNotifications',

  components: {
    DownloadEntry,
  },

  computed: {
    hasVisibleDownloads () {
      return !!this.visibleDownloadRequests.length
    },

    ...mapGetters(DOWNLOADS_NAMESPACE, [
      'visibleDownloadRequests',
    ]),
  },

  created () {
    subscribeToDownloadsChannel({ onUpdate: this.onNotificationReceived })
  },

  methods: {
    onNotificationReceived (notification) {
      this.updateDownloadRequest(notification)
    },

    ...mapActions(DOWNLOADS_NAMESPACE, [
      'updateDownloadRequest',
    ]),
  },
}
</script>

<style scoped>
.downloads-list {
  .v-snack__action {
    margin: 0;
  }

  .download-entry {
    padding: 14px 0;
    border-bottom: 1px solid gray;
  }

  .download-entry:first-child {
    padding-top: 0;
  }

  .download-entry:last-child {
    padding-bottom: 0;
    border: 0;
  }
}
</style>
